import { combineReducers } from 'redux';
import boards from './boards';
import auth from './auth';

const Pinstripe = combineReducers({
  boards, auth,
})

export default Pinstripe;


// WEBPACK FOOTER //
// ./src/reducers/index.js